<template>
  <v-row justify="center">
    <v-col cols="12" style="max-width:680px">
      <v-sheet class="pt-6">
        <h1 class="display-2 mb-6 font-weight-bold">{{
          getShopDetail('Our Story Page Title', 'Our Story')
        }}</h1>
        <v-row wrap>
          <v-col class="pb-7">
            <Markdown class="title" :source="getShopDetail('Our Story')" />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="auto">
            <v-btn large dark depressed color="blue darken-1" to="/signup"
              >Signup for a Shop</v-btn
            >
          </v-col>
          <v-col cols="auto">
            <v-btn large dark outlined color="blue darken-1" to="/"
              >Back to the Home Page</v-btn
            ></v-col
          >
        </v-row>
        <v-row wrap>
          <v-col class="pt-7">
            <Markdown
              class="about-text title"
              :source="getShopDetail('Our Story Footer')"
            />
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import Markdown from '@/components/Markdown'
export default {
  name: 'OurStoryView',
  meta() {
    return {
      title:
        'Minimart | Our Story - Supporting independent food through the pandemic.',
      meta: [
        {
          name: 'description',
          content:
            'Supporting and uplifting the independent food community is, and will always be, a core mission of our platform.',
        },
      ],
    }
  },
  components: { Markdown },
  computed: {
    ...mapGetters('shop', ['getShopDetail']),
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.about-text {
  color: rgb(30, 30, 30);
  font-family: $body-font-family;
}
</style>
